import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useReissueCheckQuery = (onSuccess: () => void, checkId?: string) => {
  const { mutateAsync, isLoading } = useMutation(
    (paymentMethodId?: string) =>
      api.put(API_URL.CHECKS_REISSUE_BY_CHECK_ID(checkId || ''), {
        ...(paymentMethodId ? { payment_method_id: paymentMethodId } : {}),
      }),
    { onSuccess }
  );
  return {
    mutateAsync,
    isLoading,
  };
};

export default useReissueCheckQuery;
